// Portal clears return parameters with replaceState({}), discarding the router's
// entry index. Preserve that entry around the notification's own dismiss events.
export default function preservePortalHistory() {
    const params = new URL(location.href).searchParams;
    if (!['signup', 'signin'].includes(params.get('action')) ||
        !['true', 'false'].includes(params.get('success'))) return;
    const bound = new WeakSet();

    function preserve() {
        const state = history.state;
        if (state?.source !== 'swup' || state.index == null) return;
        const cleaned = new URL(location.href);
        cleaned.searchParams.delete('action');
        cleaned.searchParams.delete('success');
        // A later task runs after React's bubble handler, including native
        // animation events whose listener callbacks have microtask checkpoints.
        setTimeout(() => {
            // Only repair Portal's empty state and expected URL cleanup. A newer
            // route or another integration's state must keep ownership.
            if (Object.keys(history.state || {}).length || location.href !== cleaned.href) return;
            history.replaceState({...state, url: location.pathname + location.search + location.hash}, '');
        }, 0);
    }

    function attach(frame) {
        const doc = frame.contentDocument;
        if (!doc || bound.has(doc)) return;
        bound.add(doc);
        doc.addEventListener('click', preserve, true);
        doc.addEventListener('animationend', preserve, true);
    }

    function find() {
        const frame = document.querySelector('.gh-portal-notification-iframe');
        if (!frame) return;
        frame.addEventListener('load', () => attach(frame), {once: true});
        attach(frame);
        observer.disconnect();
    }

    const observer = new MutationObserver(find);
    observer.observe(document.body, {childList: true, subtree: true});
    find();
}
